import { render } from "./TaskTile.vue?vue&type=template&id=1bbe4e56&scoped=true&ts=true&lang=pug"
import script from "./TaskTile.vue?vue&type=script&lang=ts"
export * from "./TaskTile.vue?vue&type=script&lang=ts"

import "./TaskTile.vue?vue&type=style&index=0&id=1bbe4e56&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbe4e56"]])

export default __exports__